import { render, staticRenderFns } from "./ViewMachineRepairs.vue?vue&type=template&id=1a1b7a80&"
import script from "./ViewMachineRepairs.vue?vue&type=script&lang=js&"
export * from "./ViewMachineRepairs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports